<template>
  <div class="certification-page" v-slideIn>
    <div class="page-head-container">
      <PageHead pageName="资质认证" />
    </div>
    <Steps :current="3" />
    <div class="page-wrapper" v-loading.lock="loading">
      <div class="page-empty" v-if="loading"></div>
      <div class="form-area" v-else>
        <div class="form-block" v-if="opendInfo.hasSupplier">
          <category-select
            :tree-data="categoryTree"
            :disabled="!opendInfo.supplierCanUpdate"
            @onChange="handleSupplierChange"
            :defaultCheckedKeys="certification.supplyCategory || []"
          >
            <h3 class="head">供应品类</h3>
            <!-- <div class="form-item form-item--space">
              <span class="form-item-label">
                <span class="required-symbol">*</span>厂家类型:
              </span>
              <div class="form-item-inner">
                <select
                  class="form-item-select form-item-select--large"
                  v-model="additionalCertVO.manufactorType"
                  @change="handleManufactorChange"
                >
                  <option value="" disabled>请选择</option>
                  <option :value="el.code" :key="el.code" v-for="el in manufactorOptions">{{ el.name }}</option>
                </select>
                <span class="form-item-inner--error" v-if="additionalCertVOErrors.manufactorType">
                  {{ additionalCertVOErrors.manufactorType }}
                </span>
              </div>
            </div> -->
          </category-select>
        </div>
        <div class="form-block" v-if="opendInfo.hasPurchaser">
          <category-select
            moduleType="采购"
            :tree-data="categoryTree"
            :disabled="!opendInfo.purchaserCanUpdate"
            @onChange="handlePurchaserChange"
            :defaultCheckedKeys="certification.purchaserCategory || []"
          >
            <h3 class="head">采购品类</h3>
          </category-select>
        </div>
        <div class="form-block">
          <status-info :certification="certification" />
          <h3 class="head">开户信息</h3>
          <div class="form-item">
            <span class="form-item-label">
              <span class="required-symbol" v-if="!certification.accountLicense">*</span>开户许可证:
            </span>
            <div class="form-item-inner form-item-inner--mutiiple-line">
              <Upload
                :onRemove="handleAccountLicenseUrlRemove"
                :onSuccess="handleAccountLicenseUrlSuccess"
                :action="uploadApi"
                :error="bankInfoErrors.accountLicenseUrl"
                :beforeUpload="beforeUpload"
                v-if="!certification.accountLicense"
                :url="bankInfo.accountLicensePreview"
              />
              <div class="form-item-inner--imgs" v-else>
                <div class="form-item-inner--imgs-item">
                  <img :src="bankInfo.accountLicensePreview" />
                </div>
              </div>
              <!-- <p class="form-item-inner--error">{{ bankInfoErrors.accountLicenseUrl }}</p> -->
            </div>
          </div>
          <div class="form-item">
            <span class="form-item-label">
              <span class="required-symbol" v-if="!certification.openBank">*</span>开户行:
            </span>
            <div
              v-if="certification.openBank"
              class="form-item-inner form-item-inner--text"
            >
              {{ certification.openBank }}
            </div>
            <div class="form-item-inner" v-else>
              <Input
                type="text"
                maxlength="50"
                v-model="bankInfo.openBank"
                :inline="true"
                :error="bankInfoErrors.openBank"
                :onBlur="handleFieldBlur('openBank')"
              />
            </div>
          </div>
          <div class="form-item">
            <span class="form-item-label">
              <span class="required-symbol" v-if="!certification.accountName">*</span>户名:
            </span>
            <div
              class="form-item-inner form-item-inner--text"
              v-if="certification.accountName"
            >
              {{ bankInfo.accountName }}
            </div>
            <div class="form-item-inner" v-else>
              <Input
                type="text"
                maxlength="50"
                v-model="bankInfo.accountName"
                :inline="true"
                :error="bankInfoErrors.accountName"
                :onBlur="handleFieldBlur('accountName')"
              />
            </div>
          </div>
          <div class="form-item">
            <span class="form-item-label">
              <span class="required-symbol" v-if="!certification.accountNo">*</span>帐号:
            </span>
            <div
              class="form-item-inner form-item-inner--text"
              v-if="certification.accountNo"
            >
              {{ bankInfo.accountNo }}
            </div>
            <div class="form-item-inner" v-else>
              <Input
                type="text"
                maxlength="50"
                v-model="bankInfo.accountNo"
                :inline="true"
                :error="bankInfoErrors.accountNo"
                :onBlur="handleFieldBlur('accountNo')"
                number
              />
            </div>
          </div>
        </div>
        <div class="form-block">
          <h3 class="head">基础信息</h3>
          <div class="form-item">
            <span class="form-item-label">公司名称:</span>
            <span class="form-item-inner form-item-inner--text">{{
              certification.companyNameZh
            }}</span>
          </div>
          <div class="form-item">
            <span class="form-item-label">公司简称:</span>
            <span class="form-item-inner form-item-inner--text">{{
              certification.companyAbbreviation
            }}</span>
          </div>
          <div class="form-item">
            <span class="form-item-label">公司曾用名:</span>
            <span class="form-item-inner form-item-inner--text">{{
              certification.usedCompanyName
            }}</span>
          </div>
          <div class="form-item">
            <span class="form-item-label">公司英文名:</span>
            <span class="form-item-inner form-item-inner--text">{{
              certification.companyNameEn
            }}</span>
          </div>
          <div class="form-item">
            <span class="form-item-label">所在地:</span>
            <span class="form-item-inner form-item-inner--text">{{
              certification.location
            }}</span>
          </div>
          <div class="form-item">
            <span class="form-item-label">详细地址:</span>
            <span class="form-item-inner form-item-inner--text">{{
              certification.address
            }}</span>
          </div>
          <div class="form-item">
            <span class="form-item-label">注册时间:</span>
            <span class="form-item-inner form-item-inner--text">{{
              certification.registerTime | formatDate('YYYY-MM-DD HH:mm:ss')
            }}</span>
          </div>
          <div class="form-item">
            <span class="form-item-label">企业网站:</span>
            <span class="form-item-inner form-item-inner--text">{{
              certification.website
            }}</span>
          </div>
          <div class="form-item">
            <span class="form-item-label">受邀钢厂:</span>
            <span class="form-item-inner form-item-inner--text">{{
              certification.invitedSteel || '自己感兴趣，无受邀钢厂'
            }}</span>
          </div>
          <div class="form-item">
            <span class="form-item-label">认证目的:</span>
            <span class="form-item-inner form-item-inner--text">{{
              certification.authPurpose
            }}</span>
          </div>
        </div>

        <div class="form-block">
          <h3 class="head">联系方式</h3>
          <div class="form-item">
            <span class="form-item-label">联系人:</span>
            <span class="form-item-inner form-item-inner--text">{{
              certification.contactPerson
            }}</span>
          </div>
          <div class="form-item">
            <span class="form-item-label">联系电话:</span>
            <span class="form-item-inner form-item-inner--text">{{
              certification.contactPhone
            }}</span>
          </div>
          <div class="form-item">
            <span class="form-item-label">企业电话:</span>
            <span class="form-item-inner form-item-inner--text">{{
              certification.enterprisePhone
            }}</span>
          </div>
          <div class="form-item">
            <span class="form-item-label">企业传真:</span>
            <span class="form-item-inner form-item-inner--text">{{
              certification.corporateFax
            }}</span>
          </div>
          <div class="form-item">
            <span class="form-item-label">邮编:</span>
            <span class="form-item-inner form-item-inner--text">{{
              certification.zipCode
            }}</span>
          </div>
          <div class="form-item">
            <span class="form-item-label">QQ:</span>
            <span class="form-item-inner form-item-inner--text">{{
              certification.qq
            }}</span>
          </div>
        </div>

        <div class="form-block">
          <h3 class="head">
            证件附件
            <span class="tip">资质信息提交之后不可修改，请确认信息无误，如有疑问，请联系钢信400-088-6868</span>
          </h3>
          <div class="form-item">
            <span class="img">
              <img
                v-if="certification.bizLicense"
                :src="certification.bizLicense"
              />
              <p class="file-label">营业执照</p>
              <p v-if="!certification.bizLicense" class="placeholder">
                暂未上传
              </p>
            </span>
            <span class="img">
              <img
                v-if="certification.authorization"
                :src="certification.authorization"
              />
              <p class="file-label">委托书</p>
              <p v-if="!certification.authorization" class="placeholder">
                暂未上传
              </p>
            </span>
            <span class="img">
              <img v-if="certification.orgCode" :src="certification.orgCode" />
              <p class="file-label">组织机构代码</p>
              <p v-if="!certification.orgCode" class="placeholder">暂未上传</p>
            </span>
            <span class="img">
              <img
                v-if="certification.taxRegCert"
                :src="certification.taxRegCert"
              />
              <p class="file-label">税务登记证</p>
              <p v-if="!certification.taxRegCert" class="placeholder">
                暂未上传
              </p>
            </span>
          </div>
        </div>
        <div class="form">
          <h3 class="head">外贸信息</h3>
          <div class="form-item">
            <span class="form-item-label">外贸资质:</span>
            <div class="form-item-inner form-item-inner--text">
              {{ certification.foreignTradeCert ? '具备' : '不具备' }}
            </div>
          </div>
          <template v-if="certification.foreignTradeCert">
            <div class="form-item">
              <span class="form-item-label">对外贸易经营者备案登记表附件:</span>
              <div class="form-item-inner form-item-inner--imgs">
                <span class="form-item-inner--imgs-item">
                  <img :src="certification.foreignTradeRegistry" alt />
                </span>
              </div>
            </div>
            <div class="form-item">
              <span class="form-item-label">进出口企业代码号:</span>
              <div class="form-item-inner form-item-inner--text">
                {{ certification.foreignTradeCode }}
              </div>
            </div>
          </template>
        </div>

        <div class="foot-button-container">
          <Button
            :text="isEditMode ? '确定提交' : '返回'"
            type="danger"
            :onClick="onSubmit"
            :loading="submitting"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Steps from '@/components/Steps';
import PageHead from '@/components/PageHead';
import Input from '@/components/Input';
import Button from '@/components/Button';
// import Message from '@/components/Message'
import Upload from '@/components/Upload';
import Checkbox from '@/components/Checkbox';
import CategorySelect from '@/modules/CategorySelect';

import StatusInfo from '../status';

import api from '@/api';
import auditingImg from '@/assets/auditing.png';
import auditPassImg from '@/assets/auditPass.png';
import auditRefuseImg from '@/assets/error.png';

import env from '@/utils/env';
import { mixins, validIsPurchaser, validIsSupplier } from '@/utils';

import {
  routes,
  indentityCode,
  platformCode,
  openningAndOpenedStatus,
  certificationStatusCode,
  additionalCertRules,
} from '@/config';

const fieldsRules = {
  openBank: '请输入开户行名称',
  accountName: '请输入开户银行名',
  accountNo: '请输入开户银行帐号',
  accountLicenseUrl: '请上传开户许可证',
};

export default {
  name: 'extend-company-certification',
  data() {
    return {
      auditingImg,
      auditPassImg,
      auditRefuseImg,
      token: localStorage.getItem('sso_biz_token'),

      submitting: false,
      loading: true,
      uploadApi: api.getUploadApi(),
      categoryTree: [],
      bankInfo: {
        openBank: '',
        accountName: '',
        accountNo: '',
        accountLicenseUrl: '',
        accountLicensePreview: '',
      },
      bankInfoErrors: {
        openBank: '',
        accountName: '',
        accountNo: '',
        accountLicenseUrl: '',
      },

      /** 已开通的平台列表 */
      openedPlatformList: [],

      additionalCertVO: {
        supplyCategory: [], // 供应品类
        purchaserCategory: [], // 采购品类
        manufactorType: '',
      },
      additionalCertVOErrors: {
        manufactorType: '',
      },
      /**
       * 平台信息和角色信息
       * 格式如：{ platformCode: 'fin', identityList: [] }[]
       */
      platformList: [],

      hasCert: false,
      certification: {}, // 已提交的资质信息

      uploadingFileCounts: 0, // 正在上传的文件数量
      manufactorOptions: [],
    };
  },
  mixins: [mixins],
  created() {
    setTimeout(() => {
      let baseTitle = JSON.parse(localStorage.getItem('WEB_INFO')).title || '';
      document.title = `${baseTitle} - 资质完善`;
    }, 500);
  },
  methods: {
    beforeUpload(file) {
      if (!/^image\//.test(file.type)) {
        this.$message.error('只能上传图片文件');
        return false;
      }
      if (file.size > 1024 * 1024 * 10) {
        this.$message.error('文件大小不能超过10M');
        return false;
      }
      this.uploadingFileCounts++;
      return true;
    },
    handleAccountLicenseUrlRemove() {
      this.bankInfo.accountLicenseUrl = '';
      this.bankInfoErrors.accountLicenseUrl = '请上传开户许可证';
    },
    handleAccountLicenseUrlSuccess(res) {
      this.uploadingFileCounts--;
      if (res.code === 0) {
        this.bankInfo.accountLicenseUrl = res.data.url;
        this.bankInfoErrors.accountLicenseUrl = '';
      }
    },
    validateFileUploadComplete() {
      if (this.uploadingFileCounts !== 0) {
        this.$message.error('请等待文件上传完毕再提交');
        return false;
      }
      return true;
    },
    /**
     * 厂家类型
     */
    handleManufactorChange(e) {
      const validateResult = this.validateField(
        e.target.value,
        additionalCertRules.manufactorType
      );
      this.additionalCertVOErrors.manufactorType = validateResult.error;
    },
    handleSupplierChange(data) {
      this.additionalCertVO.supplyCategory = this.resolveCategoryIds(data);
    },
    handlePurchaserChange(data) {
      this.additionalCertVO.purchaserCategory = this.resolveCategoryIds(data);
    },
    handleFieldBlur(name) {
      return this.validateFieldWithErrors(
        this.bankInfoErrors,
        fieldsRules,
        name
      );
    },
    validate() {
      // 招采页面暂不加
      // if (this.shouldSubmitSupplierInfo) {
      //   const { isValid, errors } = this.validateFields({ manufactorType: this.additionalCertVO.manufactorType }, additionalCertRules);
      //   this.additionalCertVOErrors = errors;
      //   if (!isValid) {
      //     return false;
      //   }
      // }

      if (
        this.shouldSubmitSupplierInfo &&
        !this.additionalCertVO.supplyCategory.length
      ) {
        this.$message.error('请选择供应品类');
        return false;
      }

      if (
        this.shouldSumitPurchaserInfo &&
        !this.additionalCertVO.purchaserCategory.length
      ) {
        this.$message.error('请选择采购品类');
        return false;
      }

      // 如果此字段不为空，则代表之前是已经填写过了，现在只是回显..
      if (
        this.certification.accountLicense &&
        this.certification.accountNo &&
        this.certification.accountName
      ) {
        return true;
      }

      const { isValid, errors } = this.validateFields(
        this.bankInfo,
        this.filterValueKeys(fieldsRules, this.shouldEditFields, true)
      );

      this.bankInfoErrors = errors;
      return this.validateFileUploadComplete() && isValid;
    },

    onSubmit() {
      if (!this.isEditMode) {
        return this.gotoSourcePage();
      }

      if (this.validate()) {
        this.submitData();
      }
    },
    submitData() {
      const identityList = [];
      const isBid = this.opendInfo.isBid;

      if (this.opendInfo.hasPurchaser) {
        identityList.push(isBid ? indentityCode.bid.purchaser : indentityCode.cenpur.purchaser);
      }
      if (this.opendInfo.hasSupplier) {
        identityList.push(isBid ? indentityCode.bid.supplier : indentityCode.cenpur.supplier);
      }

      const data = {
        bankInfo: this.bankInfo,
        additionalCertVO: {
          supplyCategory: this.additionalCertVO.supplyCategory.length
            ? this.additionalCertVO.supplyCategory
            : null,
          purchaserCategory: this.additionalCertVO.purchaserCategory.length
            ? this.additionalCertVO.purchaserCategory
            : null,
        },
        platformList: [
          {
            platformCode: isBid ? platformCode.bid : platformCode.cenpur,
            identityList,
          },
        ],
        isCompleteCert: true, // 写死为true，代表惠唐补充资质，其他页面请传false
      };

      if (this.shouldSubmitSupplierInfo) {
        // data.additionalCertVO.manufactorType = this.additionalCertVO.manufactorType;
      }

      this.$confirm('您确定要立即提交吗？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.submitting = true;
        api.updateUserCert(data).then(data => {
          this.submitting = false;
          if (data.code === 0) {
            this.$message.success('提交成功，正在返回来源页面');
            setTimeout(() => {
              this.gotoSourcePage();
            }, 1000);
          }
        });
      });
    },
    gotoSourcePage() {
      window.location.href =
        decodeURIComponent(this.$route.query.redirect_url) ||
        'https://www.zlgx.com';
    },
    getSupplyCategoryTree() {
      return api.getSupplyCategoryTree({ platformCode: 'bid' }).then(res => {
        this.categoryTree = res.data;
      });
    },
    getServicesInfo() {
      return api
        .getServiceInfo({
          token: this.token,
        })
        .then(data => {
          if (data && data.code === 0) {
            this.openedPlatformList = data.data;
          }
        });
    },

    async init() {
      this.loading = true;
      await this.getSupplyCategoryTree();
      await this.getCertificationInfo();
      await this.getServicesInfo();
      this.loading = false;
    },
    getCertificationInfo() {
      return api.getCertificationInfo().then(res => {
        if (res.code === 0) {
          if (res.data) {
            this.certification = res.data;
            this.certification.accountLicenseUrl = this.certification.accountLicense;
            this.accountLicense = this.certification.accountLicenseFileKey;
            this.address = this.certification.address;
            this.authorization = this.certification.authorizationFileKey;
            this.bizLicense = this.certification.bizLicenseFileKey;
            this.companyNameZh = this.certification.companyNameZh;
            this.companyNameEn = this.certification.companyNameEn;
            this.contactPerson = this.certification.contactPerson;
            this.contactPhone = this.certification.contactPhone;
            this.orgCode = this.certification.orgCodeFileKey;
            this.taxRegCert = this.certification.taxRegCertFileKey;

            this.bankInfo.accountLicensePreview = this.certification.accountLicense;
            this.bankInfo.accountLicenseUrl = this.certification.accountLicenseFileKey;
            this.bankInfo.openBank = this.certification.openBank;
            this.bankInfo.accountName = this.certification.accountName;
            this.bankInfo.accountNo = this.certification.accountNo;
            this.additionalCertVO.purchaserCategory =
              this.certification.purchaserCategory || [];
            this.additionalCertVO.supplyCategory =
              this.certification.supplyCategory || [];
          }
        }
      });
    },
  },
  mounted() {
    this.init();
  },
  computed: {
    opendInfo() {
      const certification = this.certification;
      const openedPlatformList = this.openedPlatformList;

      const cenpurPlatform = openedPlatformList.find(
        el => el.platformCode === platformCode.cenpur || el.platformCode === platformCode.bid
      ) || {
        identity: [],
      };

      const isBid = cenpurPlatform.platformCode === platformCode.bid;
      const isCenpur = cenpurPlatform.platformCode === platformCode.cenpur;

      const purchaser =
        cenpurPlatform.identity.find(
          el => validIsPurchaser(el.code)
        ) || {};
      const supplier =
        cenpurPlatform.identity.find(
          el => validIsSupplier(el.code)
        ) || {};

      return {
        isBid,
        isCenpur,
        hasPurchaser: certificationStatusCode.opened === purchaser.status,
        hasSupplier: certificationStatusCode.opened === supplier.status,

        purchaserCanUpdate: !certification.purchaserCategory,
        supplierCanUpdate: !certification.supplyFullCategory,
      };
    },
    shouldEditFields() {
      const certification = this.certification;
      return [
        'openBank',
        'accountNo',
        'accountName',
        'accountLicenseUrl',
      ].filter(el => {
        return !certification[el];
      });
    },
    isEditMode() {
      return !!(
        this.shouldEditFields.length ||
        this.opendInfo.supplierCanUpdate ||
        this.opendInfo.purchaserCanUpdate
      );
    },
    shouldSubmitSupplierInfo() {
      return this.opendInfo.hasSupplier && this.opendInfo.supplierCanUpdate;
    },
    shouldSumitPurchaserInfo() {
      return this.opendInfo.hasPurchaser && this.opendInfo.purchaserCanUpdate;
    },
  },
  components: {
    Steps,
    Input,
    Button,
    Upload,
    PageHead,
    CategorySelect,
    Checkbox,
    StatusInfo,
  },
};
</script>
<style lang="scss" scoped>
@import '../style';
</style>
